import PropTypes from 'prop-types';
import FJCheckIcon from '../../../../assets/svg/check.svg?react';
import classNames from 'classnames';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJImage from '../../../../common/components/FJImage/FJImage';
import FJTextWithEllipsisParent from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';

import styles from './OptionCard.module.less';

const OptionCard = ({ title, imageUrl, isSelected, onClick, multiple = false, disabled }) => {
    return (
        <div
            className={classNames(styles.option_card, { [styles.active]: isSelected, [styles.disabled]: disabled })}
            onClick={onClick}
        >
            <FJHoverBoardGradation
                className={styles.hover_board_box}
                active={isSelected}
                isShowInBorder
                borderRadius={12}
            >
                <div className={styles.aspect_ratio_box}>
                    <FJImage
                        imgSrc={imageUrl}
                        imgClassName={styles.option_image}
                        boxClassName={styles.option_image_box}
                        isShowLoading
                        onRefresh={onClick}
                    />

                    {(multiple || isSelected) && (
                        <div className={classNames(styles.selected_icon, { [styles.selected]: isSelected })}>
                            <FJCheckIcon fill='currentColor' />
                        </div>
                    )}

                    <div className={styles.option_content}>
                        <FJTextWithEllipsisParent className={styles.option_title} text={title} />
                    </div>
                </div>
            </FJHoverBoardGradation>
        </div>
    );
};

OptionCard.propTypes = {
    title: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    imageAlt: PropTypes.string,
    multiple: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default OptionCard;
